import * as Sentry from "@sentry/react";
import { RouterProvider } from "react-router-dom";
import { Providers } from "@/app/providers";
import { router } from "@/app/router";
import { DisclaimerModal } from "@/features/legal/DisclaimerModal";

function AppInner() {
  return (
    <Providers>
      <RouterProvider router={router} />
      <DisclaimerModal />
    </Providers>
  );
}

export const App = Sentry.withSentryReactRouterV6Routing(
  Sentry.withProfiler(AppInner),
);
